import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/requests/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const { requestResources } = useSelector((state) => state.requests);
  const [requestResourcesOptions, setRequestResourcesOptions] = useState([]);
  const payload = { page: 1, requestStatus: 12, sort: "created_at,desc" };

  const initialValues = {
    search: "",
    requestSource: 0, //ddl
  };

  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    requestSource: Yup.object().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  useEffect(() => {
    if (!requestResources.length) dispatch(actions.requestSourcesRequest());
    return () => {
      dispatch(actions.requestSourcesReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //add all option
    if (requestResources.length)
      setRequestResourcesOptions([
        { id: 0, name: messages.requests.all_sources },
        ...requestResources,
      ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestResources]);

  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: e.target.value, requestSource: formik.values.requestSource });
    dispatch(
      actions?.completedRequestsRequest({
        ...payload,
        ...formik.values,
        search: e.target.value,
      })
    );
  };
  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, requestSource: e.target.value });
    dispatch(
      actions?.completedRequestsRequest({
        ...payload,
        ...formik.values,
        requestSource: e.target.value,
      })
    );
  };
  
  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.requests.search_by_phone_or_name_or_id_placholder}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="requestSource"
              list={requestResourcesOptions}
              keyName="name"
              valueKeyName="id"
              value={formik.values.requestSource}
              handleChange={(e) => searchWithSelect(e, "requestSource")}
              error={formik.errors.requestSource}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
